import { ContextDataPageTypeEnum } from '@redteclab/api/clients/adserver-api'
import { algoliasearchWithAds } from '@redteclab/retail-media-adserver-algolia-wrapper'
import type { SearchClient as AlgoliaWrapperSearchClient } from '@redteclab/retail-media-adserver-algolia-wrapper/src/types'
import Cookies from 'cookies'

import { DEFAULT_FILTERS_LIST, PAGE_TYPE_CATEGORY } from 'shared/consts'
import { AD_SERVER_USER_ID_COOKIE } from 'shared/consts/adServer'
import logger from 'shared/services/logger'
import {
  getSetAdUserIdentity,
  mapAdServerIdsToAcronymIds,
} from 'shared/utils/adServerUtils'
import type { PageProperties } from 'types/pageProperties'
import type { PublicConfig } from 'types/shopConfig'
import { getTargetingContext } from 'views/utils/adServerUtils'

export const getSearchClientWithAds = ({
  searchClient,
  pageProperties,
  publicConfig,
  cookies,
}: {
  searchClient: AlgoliaWrapperSearchClient
  pageProperties: PageProperties
  publicConfig: PublicConfig
  cookies: Cookies
}) => {
  const {
    adServer,
    searchConfig: {
      algolia: { indexName, mpIndexName },
      topSellerCount: { indexName: topSellerIndexName },
    },
  } = publicConfig
  const { adServerSideContext, adServerAlgoliaWrapperAdsData, pageType } =
    pageProperties

  const defaultIndexName =
    pageType === PAGE_TYPE_CATEGORY ? topSellerIndexName : indexName

  const adServerContext = getTargetingContext({
    publicRuntimeConfig: {
      pageProperties,
      publicConfig,
    },
    adServerSideContext,
  })

  const query = pageProperties.cmsContentCode

  const adServerUser = mapAdServerIdsToAcronymIds({
    ...getSetAdUserIdentity(cookies),
    userId: cookies.get(AD_SERVER_USER_ID_COOKIE),
  })

  return algoliasearchWithAds(searchClient, {
    adServerApiUrl: adServer.apiUrl,
    adServerContext: {
      ...(adServerContext || {}),
      searchTerm: query,
      pageType: ContextDataPageTypeEnum.Category,
    },
    adServerUser,
    defaultIndexName,
    onError: logger.error.bind(logger),
    adsData: adServerAlgoliaWrapperAdsData,
    defaultMarketplaceIndexName: mpIndexName,
    defaultFilters: Array.from(DEFAULT_FILTERS_LIST),
  })
}
